import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { WorkspaceData } from '../../../stores/workspaces.state';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StoragePipeModule } from '@shared/utils';
import { LoadingAttributeComponent } from '@shared/ui';

export enum WorkspaceColumn {
  NAME = 'name',
  CASE_TYPE = 'caseType',
  STORAGE = 'storage',
  STATS = 'stats',
}

export interface CaseTypeData {
  id: string;
  name: string;
}

export interface WorkspaceListItem extends WorkspaceData {
  caseType?: CaseTypeData;
}

@Component({
  selector: 'ts-workspaces-list',
  templateUrl: './workspaces-list.component.html',
  styleUrls: ['./workspaces-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoragePipeModule, LoadingAttributeComponent, TranslateModule, MatTableModule, CommonModule],
})
export class WorkspacesListComponent implements OnChanges {
  @Input() items: WorkspaceListItem[] = [];
  @Input() loading = false;
  @Input() noWorkspaces = false;
  @Input() columns: WorkspaceColumn[] = [
    WorkspaceColumn.NAME,
    WorkspaceColumn.CASE_TYPE,
    WorkspaceColumn.STORAGE,
    WorkspaceColumn.STATS,
  ];

  @Output() workspaceClicked = new EventEmitter<WorkspaceListItem>();

  containerHeight: number | null = null;

  constructor(private elementRef: ElementRef) {}

  trackByWorkspaceId(_index: number, row: WorkspaceListItem): string {
    return row.id;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading'] && changes['loading'].currentValue === true) {
      const element = this.elementRef.nativeElement as HTMLElement;
      if (element && element.offsetHeight > 0) {
        this.containerHeight = element.offsetHeight;
      }
    }
    if (changes['loading'] && changes['loading'].currentValue === false) {
      this.containerHeight = null;
    }
  }
}
